export var OrbiObjectType;
(function (OrbiObjectType) {
    OrbiObjectType["Global"] = "Global";
    OrbiObjectType["GithubParent"] = "GithubParent";
    OrbiObjectType["GithubRepo"] = "GithubRepo";
    OrbiObjectType["GithubReleaseForRepo"] = "GithubReleaseForRepo";
    OrbiObjectType["GithubPrsForRepo"] = "GithubPrsForRepo";
    OrbiObjectType["GithubCommitsForRepo"] = "GithubCommitsForRepo";
    OrbiObjectType["GithubVulnsForRepo"] = "GithubVulnsForRepo";
    OrbiObjectType["GithubWorkflowsForRepo"] = "GithubWorkflowsForRepo";
    OrbiObjectType["GithubWorkflowRunsForRepo"] = "GithubWorkflowRunsForRepo";
    OrbiObjectType["GithubWebhookEvent"] = "GithubWebhookEvent";
    OrbiObjectType["GithubUser"] = "GithubUser";
    OrbiObjectType["GithubUserOauthInfo"] = "GithubUserOauthInfo";
    OrbiObjectType["GithubTeam"] = "GithubTeam";
    OrbiObjectType["GithubTeamMember"] = "GithubTeamMember";
    OrbiObjectType["GithubRepoAccessControl"] = "GithubRepoAccessControl";
    OrbiObjectType["GithubEnvironment"] = "GithubEnvironment";
    OrbiObjectType["GithubSecret"] = "GithubSecret";
    OrbiObjectType["GithubWebhookCallback"] = "GithubWebhookCallback";
    OrbiObjectType["Postprocessanalyze"] = "Postprocessanalyze";
    OrbiObjectType["Postprocessproductivity"] = "Postprocessproductivity";
})(OrbiObjectType || (OrbiObjectType = {}));
